import clsx from 'clsx';
import ItemComplexList from 'core/modules/components/general/ItemComplexList';
import ProgramImage from 'core/modules/components/general/ProgramImage/ProgramImage';
import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';

const CalendarItem = ({
  iconType,
  gradient,
  name,
  showGroupName,
  school_group_name,
  education_year_name,
  education_level_name,
  visible,
  guid,
  onClickVisible,
  showOptions,
  onConfigureCourse,
  configProgramPicture,
  course_picture,
  calendarTheme,
  courseGuid,
  themeColor,
  themeImage,
}) => {
  function renderLeft() {
    return <div className="calendar-item__course-color" style={{ backgroundColor: themeColor }}></div>;
  }

  function renderCenter() {
    return (
      <div className={clsx('calendar-item__info', { 'calendar-item__info--invisible': !visible })}>
        <ProgramImage
          configProgramPicture={configProgramPicture}
          calendarTheme={calendarTheme}
          iconType={iconType}
          gradient={themeColor ? themeColor : gradient}
          course_picture={course_picture}
          themeImage={themeImage}
        />

        <div className="calendar-item__text-wrapper">
          <div className="calendar-item__name" title={name}>
            {name}
          </div>
          {showGroupName && (
            <div className="calendar-item__level" title={school_group_name}>
              {school_group_name}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <ul className="calendar-item">
      <ItemComplexList
        left={renderLeft()}
        center={renderCenter()}
        right={
          <div className="calendar-item__options-wrapper">
            <div className="calendar-item__visible-icon" onClick={() => onClickVisible(guid)}>
              <Icon size="md" name={visible ? 'visible' : 'visible-off'} />
            </div>
            {showOptions && (
              <div className="calendar-item__options" onClick={onConfigureCourse}>
                <Icon name="settings" size="md" />
              </div>
            )}
          </div>
        }
      />
    </ul>
  );
};

CalendarItem.propTypes = {
  iconType: PropTypes.string,
  gradient: PropTypes.string,
  guid: PropTypes.string,
  name: PropTypes.string,
  visible: PropTypes.bool,
  onClickVisible: PropTypes.func,
};

CalendarItem.defaultProps = {
  visible: true,
  onClickVisible: {},
};

export default CalendarItem;
